import React, { Component } from 'react';
import { Container, Header, Icon, List } from 'semantic-ui-react';
import './home.css';
import Iframe from 'react-iframe';
class CompanyCalendarCard extends Component {
  genHeader() {
    if (this.props.mobile !== true) {
      return (
        <Header as="h3">
          <Icon name="calendar" />
          Company Calendar
        </Header>
      );
    }
  }
  render() {
    return (
      <Container>
        <Header as="h3">
          <Icon color="black" name="calendar" /> Company Calendar
        </Header>
        <div id="calendarList">
          <Iframe
            url="https://calendar.google.com/calendar/embed?showTitle=0&amp;showNav=0&amp;showPrint=0&amp;showTabs=0&amp;showCalendars=0&amp;showTz=0&amp;mode=AGENDA&amp;height=300&amp;wkst=2&amp;bgcolor=%23ffffff&amp;src=edfinc.calendar%40gmail.com&amp;color=%232F6309&amp;src=en.usa%23holiday%40group.v.calendar.google.com&amp;color=%23182C57&amp;ctz=America%2FNew_York"
            width="100%"
            height="450px"
            id="myId"
            className="myClassname"
            display="initial"
            position="relative"
          />
        </div>
      </Container>
    );
  }
}
export default CompanyCalendarCard;



// WEBPACK FOOTER //
// ./src/components/home-components/companycalendar.js